'use strict';

import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

/**
 * @classname InterviewParallax
 * @classdesc Interviewパララックス
 */
export default class InterviewParallax {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('InterviewParallax.constructor');
		this._controller = new ScrollMagic.Controller();
		this.photoLeftAnimation();
		this.centerAnimation();
		this.photoRightAnimation();
	};


	/**
	 * 写真左
	 *
	 * @memberof InterviewParallax
	 * @return {undefined}
	 */
	photoLeftAnimation() {
		console.log('InterviewParallax.photoLeftAnimation');
		const contents = $('.block--photo-left .block__item--contents');
		for(let i = 0; i < contents.length; i++) {
			new ScrollMagic.Scene({
				triggerElement: contents[i],
				triggerHook: 0.9
			})
				.setClassToggle(contents[i], 'visible')
				.addTo(this._controller);
		}
		const photo = $('.block--photo-left .block__item--photo');
		for(let j = 0; j < photo.length; j++) {
			new ScrollMagic.Scene({
				triggerElement: photo[j],
				triggerHook: 0.9
			})
				.setClassToggle(photo[j], 'visible')
				.addTo(this._controller);
		}
	};


	/**
	 * 写真中央
	 *
	 * @memberof InterviewParallax
	 * @return {undefined}
	 */
	centerAnimation() {
		console.log('InterviewParallax.centerAnimation');
		const contents = $('.block--photo-center .block__item--contents');
		for(let i = 0; i < contents.length; i++) {
			new ScrollMagic.Scene({
				triggerElement: contents[i],
				triggerHook: 0.9
			})
				.setClassToggle(contents[i], 'visible')
				.addTo(this._controller);
		}
		const photo = $('.block--photo-center .block__item--photo');
		for(let j = 0; j < photo.length; j++) {
			new ScrollMagic.Scene({
				triggerElement: photo[j],
				triggerHook: 0.9
			})
				.setClassToggle(photo[j], 'visible')
				.addTo(this._controller);
		}
	};


	/**
	 * 写真右
	 *
	 * @memberof InterviewParallax
	 * @return {undefined}
	 */
	photoRightAnimation() {
		console.log('InterviewParallax.photoRightAnimation');
		const contents = $('.block--photo-right .block__item--contents');
		for(let i = 0; i < contents.length; i++) {
			new ScrollMagic.Scene({
				triggerElement: contents[i],
				triggerHook: 0.9
			})
				.setClassToggle(contents[i], 'visible')
				.addTo(this._controller);
		}
		const photo = $('.block--photo-right .block__item--photo');
		for(let j = 0; j < photo.length; j++) {
			new ScrollMagic.Scene({
				triggerElement: photo[j],
				triggerHook: 0.9
			})
				.setClassToggle(photo[j], 'visible')
				.addTo(this._controller);
		}
	};




};